import React from 'react';
import ArticleList from '~/components/blog/articleList';
import Countries from '~/components/countries_enum.ts';
import { getArticlesList } from '~/components/blog/article_service.ts';
import SEO from '~/components/seo';
import { t } from '@lingui/macro';

const BlogIndex = ({ posts }) => {
    return (
        <>
            <SEO title={t`Blog`} />
            <ArticleList posts={posts} country={Countries.ITALY} />
        </>
    );
};

export const getServerSideProps = async ({ query }) => {
    const articlesData = await getArticlesList(query, Countries.ITALY);

    return {
        props: {
            posts: JSON.stringify(articlesData),
        },
    };
};

export default BlogIndex;
